<template>
  <div>
    <div class="pagePopMask pFull" v-if="infoPop" @click="cancelImpEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="infoPop">
      <div class="w">
        <div class="tit fnt_32">查看</div>
        <div>
          <a-table :columns="columns" :data-source="tableData" :pagination="false">
            <template slot="action" slot-scope="record">
              <a @click="handleView(record)">下载</a>
            </template>
          </a-table>
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="confirmImpEdit">{{ globalDataArray.siteTemplateLanguage.save }}</div>
          <div class="btn btn2" @click="cancelImpEdit">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click="cancelImpEdit"></div>
      </div>
    </div>
  </div>
</template>
<script>

import { updateMember } from '@/api/person/person'

import { defineComponent } from 'vue'
const columns = [
  // { title: '证书编号', dataIndex: 'certificateNumber', key: 'certificateNumber' },
  { title: '获奖人姓名', dataIndex: 'recipientName', key: 'recipientName' },
  { title: '编号', dataIndex: 'certificateNumber', key: 'certificateNumber' },
  // { title: '颁发机构', dataIndex: 'issuer', key: 'issuer' },
  // { title: '证书标题', dataIndex: 'title', key: 'title' },
  // { title: '证书描述', dataIndex: 'description', key: 'description' },
  // { title: 'pdf文件', dataIndex: 'pdfUrl', key: 'pdfUrl' },
  // { title: '预览图', dataIndex: 'previewImageUrl', key: 'previewImageUrl' },
  // { title: '获奖日期', dataIndex: 'awardDate', key: 'awardDate' },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

const data = []

export default {
  name: 'PersonCheck',
  props: {
    checkList: {
      type: Array,
      default: () => []
    },
    infoPop: {
      type: Boolean,
      default: false
    },
    person: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      studentInfo: {
        ...this.person
      },
      tableData: [],
      columns
    }
  },
  watch: {
    checkList: {
      immediate: true,
      handler(val) {
        this.tableData = val || []
      }
    }
  },
  created() {
    console.log('checkList数据：', this.checkList)
  },
  methods: {
    handleView(record) {
      // 处理下载逻辑
      console.log('handleView调用，record参数:', record)

      if (!record) {
        console.error('record参数为空')
        this.$message?.error('数据错误')
        return
      }

      const fileUrl = record.pdfUrl
      if (!fileUrl) {
        console.log('文件URL缺失')
        this.$message?.error('文件链接缺失')
        return
      }

      try {
        console.log('开始下载文件:', fileUrl)

        // 从URL中提取文件扩展名
        const urlParts = fileUrl.split('.')
        const fileExtension = urlParts[urlParts.length - 1].toLowerCase()

        // 设置下载文件名，保持原始扩展名
        const fileName = `${record.recipientName || '证书'}_${record.certificateNumber || 'certificate'}.${fileExtension}`

        // 使用XMLHttpRequest下载文件
        const xhr = new XMLHttpRequest()
        xhr.open('GET', fileUrl, true)
        xhr.responseType = 'blob'

        xhr.onload = function() {
          if (xhr.status === 200) {
            const blob = xhr.response
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            a.download = fileName

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)

            // 清理blob URL
            window.URL.revokeObjectURL(url)

            console.log('文件下载成功:', fileName)
            this.$message?.success('文件下载成功！')
          } else {
            console.error('下载失败，状态码:', xhr.status)
            this.$message?.error('下载失败，请稍后重试')
          }
        }.bind(this)

        xhr.onerror = function() {
          console.error('XMLHttpRequest下载失败')
          this.$message?.error('下载失败，网络错误')

          // 备用方案：在新窗口打开
          console.log('使用备用方案：新窗口打开')
          window.open(fileUrl, '_blank')
        }.bind(this)

        xhr.onprogress = function(e) {
          if (e.lengthComputable) {
            const percentComplete = (e.loaded / e.total) * 100
            console.log('下载进度:', percentComplete.toFixed(2) + '%')
          }
        }

        this.$message?.info('正在下载文件，请稍候...')
        xhr.send()
      } catch (error) {
        console.error('下载文件失败:', error)
        this.$message?.error('下载失败，请稍后重试')

        // 备用方案：在新窗口打开
        window.open(fileUrl, '_blank')
      }
    },
    cancelImpEdit() {
      this.tableData = []
      this.$emit('update:infoPop', false)
    },
    confirmImpEdit() {
    // 由于这是查看功能，直接调用取消方法关闭弹框
      this.cancelImpEdit()
    }
  }
}

</script>
